import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'auth/AuthProvider';
import { queryKeys } from 'core/api/queryKeys';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { userApi } from 'features/home/home.api';
import { AppShell, BrandLink, ShellMain } from 'layout/AppShell';
import { FocusedAssessmentLayout } from 'layout/FocusedAssessmentLayout';
import { usePersistPreferredLocale } from 'layout/usePersistPreferredLocale';
import { DashboardNavLinks } from 'navigation/DashboardNavigation';
import { LanguageSwitcher } from 'shared/components/LanguageSwitcher';

export function DashboardLayout() {
  const location = useLocation();
  if (/^\/assessment\/\d+/.test(location.pathname)) {
    return <FocusedAssessmentLayout />;
  }
  return <DashboardChrome />;
}

function DashboardChrome() {
  const { t } = useI18n();
  const { user } = useAuth();
  const persistLocale = usePersistPreferredLocale();
  const unreadQuery = useQuery({
    queryKey: queryKeys.unreadCount,
    queryFn: () => userApi.unreadCount(),
    refetchOnWindowFocus: true,
  });
  const unread = Number(unreadQuery.data?.unread_count || 0);

  return (
    <AppShell className="dashboard-shell" compactFooter>
      <header className="site-header">
        <div className="shell-container header-inner">
          <BrandLink to={paths.home} />
          <div className="header-end">
            <NavLink to={paths.notifications} className="header-bell" aria-label={t('nav.notifications')}>
              {unread > 0 ? <span className="nav-dot" /> : null}
            </NavLink>
            <LanguageSwitcher onChange={persistLocale} />
            <span className="header-user">{user?.name}</span>
          </div>
        </div>
      </header>
      <div className="chip-nav-wrap">
        <div className="shell-container">
          <DashboardNavLinks
            className="chip-nav"
            ariaLabel={t('layout.dashboardNavigation')}
            unread={unread}
          />
        </div>
      </div>
      <div className="shell-container dashboard-body">
        <ShellMain className="dashboard-main">
          <Outlet />
        </ShellMain>
      </div>
    </AppShell>
  );
}

export { DashboardLayout as AppLayout };
